import { ValidationResult } from '../../editor/EditorTypes';
import { CheckCircleIcon, XCircleIcon, ExclamationTriangleIcon, InformationCircleIcon } from '@heroicons/react/24/outline';

interface ValidationPanelProps {
  validation?: ValidationResult;
}

export function ValidationPanel({ validation }: ValidationPanelProps) {
  if (!validation) {
    return null;
  }

  return (
    <div className="validation-panel">
      <h3>Validation</h3>
      
      {validation.valid ? (
        <div className="validation-success">
          <CheckCircleIcon style={{ width: '16px', height: '16px', display: 'inline-block', verticalAlign: 'middle', marginRight: '6px' }} />
          Level is valid and playable!
        </div>
      ) : (
        <div className="validation-error">
          <XCircleIcon style={{ width: '16px', height: '16px', display: 'inline-block', verticalAlign: 'middle', marginRight: '6px' }} />
          Level has errors that must be fixed
        </div>
      )}

      {validation.errors.length > 0 && (
        <div className="validation-section">
          <h4>Errors:</h4>
          <ul>
            {validation.errors.map((error, idx) => (
              <li key={idx} className="validation-item error">
                <XCircleIcon style={{ width: '14px', height: '14px', display: 'inline-block', verticalAlign: 'middle', marginRight: '4px' }} />
                {error}
              </li>
            ))}
          </ul>
        </div>
      )}

      {validation.warnings.length > 0 && (
        <div className="validation-section">
          <h4>Warnings:</h4>
          <ul>
            {validation.warnings.map((warning, idx) => (
              <li key={idx} className="validation-item warning">
                <ExclamationTriangleIcon style={{ width: '14px', height: '14px', display: 'inline-block', verticalAlign: 'middle', marginRight: '4px' }} />
                {warning}
              </li>
            ))}
          </ul>
        </div>
      )}

      {validation.info.length > 0 && (
        <div className="validation-section">
          <h4>Info:</h4>
          <ul>
            {validation.info.map((info, idx) => (
              <li key={idx} className="validation-item info">
                <InformationCircleIcon style={{ width: '14px', height: '14px', display: 'inline-block', verticalAlign: 'middle', marginRight: '4px' }} />
                {info}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
